import * as React from 'react';

const Rectangle43Svg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M3 18h18V6H3v12zM2 5h20v14H2V5z" fillRule="nonzero" />
    </svg>
);

Rectangle43Svg.displayName = 'Rectangle43Svg';
export default Rectangle43Svg;
